export default "__VITE_ASSET__D0G026LG__"